import React from "react";
import "../../Components/globalVariables.js";

const TermsOfService = () => {
  return (
    <div style={{ width: "100%", height: "100vh", background: "#fff" }}>
      <iframe
        src={global.terms_of_service_viewer} 
        title="Terms of Service"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default TermsOfService;
